import { AxiosResponse } from 'axios'
import { action } from 'typesafe-actions'
import { ApiActionTypes } from './types'

export const apiReject = (error: AxiosResponse<any>) => action(ApiActionTypes.REJECTED, error)
